// Site-wide configuration — loaded from CMS-managed content (src/content/settings/site.json).
//
// Alleen nog de algemene ticket-bestemming voor de knop "Kaartjes" in de
// navigatie, de footer en de hero. Het uitgelichte event op de homepage stond
// hier vroeger als aparte kopie van een event, inclusief eigen datum en prijs.
// Dat kon uit de pas lopen met de evenementenpagina zonder foutmelding, dus de
// band haalt zijn gegevens nu rechtstreeks uit src/content/events via
// `pickHomepageEvent` in src/data/events.js.

import site from '@/content/settings/site.json';

export const TICKET_URL = site.ticketUrl;
